import { DynamicObjectInterface } from '../type';
import { AxiosUtilsType, axiosPost, axiosGet, axiosDelete } from './axiosUtils';
import './axiosInterceptor';

// MY create-team -> team-leader registration handoff. Stashes the chosen order
// number + matched subChallengeId keyed by a UUID so registration can be
// resumed (even after a browser close) with both already locked in.
const RegistrationResumeService = {
  async create(payload: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPost(`registrationResume`, payload);
  },

  async get(resumeId: string): AxiosUtilsType {
    return await axiosGet(`registrationResume/${resumeId}`);
  },

  // Resume-by-order: look up an existing handoff row by abo + order number so the
  // user can resume registration after closing the browser (no UUID to remember).
  async find(payload: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPost(`registrationResume/find`, payload);
  },

  async remove(resumeId: string): AxiosUtilsType {
    return await axiosDelete(`registrationResume/${resumeId}`);
  },
};
export default RegistrationResumeService;
